import React from 'react';
import PageHeader from '../components/PageHeader';
import '../css/deansw.css'; // Update the CSS file name

const MBAwrittentest = () => {
    return (

        <div class="container">

            <div class="row">
                <br />
                <h4 align='center'>
                    MBA ADMISSIONS 2025
                </h4>
                <h5 align='center'><u>SCHEDULE OF GROUP DISCUSSION (GD) AND PERSONAL INTERVIEW (PI) AND LIST OF ELIGIBLE CANDIDATES</u>
                </h5><br />
                <table class="table table-bordered table-striped table-hover">
                    <thead class="table-dark text-center">
                        <tr>
                            <th>Details</th>
                            <th>Date</th>
                            <th>Mode & Contact Details</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td >Group Discussion and Personal Interview (GD & PI)</td>
                            <td>
                                <b>19.05.2025 (for candidates
                                    with serial nos. 1 to 85)</b>
                                <br />
                                <b>20.05.2025 (for candidates
                                    with serial nos. 86 to 170)</b>
                                <br />
                                <b>21.05.2025 (for candidates
                                    with serial nos. 171 to 253 )</b>

                            </td>
                            <td >
                                OFFLINE<br />
                                Head, Department of Management Studies<br />
                                NIT Warangal<br />
                                Contact: 9490165349<br />
                                Email: <a href="mailto:som_hod@nitw.ac.in">som_hod@nitw.ac.in</a>
                            </td>
                        </tr>
                        <tr>
                            <td>Announcement of 1st Phase Results:</td>
                            <td>23.05.2025</td>
                            <td>Institute Website</td>
                        </tr>
                        <tr>
                            <td>Remaining Phases Results</td>
                            <td>Visit the Institute Website</td>
                            <td><a href="https://admissions.nitw.ac.in/">Institute Website</a></td>
                        </tr>
                    </tbody>
                </table>
                <p className="mb-2">
                    Candidates are required to report physically to the Head, Department of Management Studies by <strong>8:30 a.m.</strong> on the scheduled day of GD&amp;PI.
                    The candidates should contact the Head, Department of Management Studies for any information related to the GD&amp;PI.
                </p>

                <p className="mb-2">
                    The candidates should attend the GD &amp; PI with all relevant original certificates, without which they will not be allowed to attend the GD &amp; PI.
                </p>

                <p className="mb-2">
                    The candidate should produce the following original certificates for verification:
                </p>

                <ul className="mb-4">
                    <li>1. Class X certificate for proof of date of birth.</li>
                    <li>2. Class XII / Intermediate / 10+2 certificate.</li>
                    <li>
                        3. Marks sheets / consolidated marks or grade sheet of Bachelor’s degree
                        (in case, the candidate is appearing for the final examinations, the candidate should produce
                        the marks memoranda / grade sheets of all the examinations up to pre-final year/semester).
                    </li>
                    <li>4. SC / ST caste certificate, if applicable.</li>
                    <li>
                        5. EWS certificate in the prescribed format given in the institute website, issued on or after <strong>01-04-2025</strong>, if applicable.
                    </li>
                    <li>
                        6. OBC-NCL certificate in the prescribed format given in the institute website, issued on or after <strong>01-04-2025</strong>, if applicable.
                    </li>
                    <li>7. Persons with Disability (PwD) certificate, if applicable.</li>
                    <li>8. Degree / Provisional pass certificate of the qualifying examination.</li>
                    <li>
                        9. In case final result is awaited, a provisional pass certificate should be submitted at the time of counseling
                        or before the date mentioned in the brochure, failing which the admission shall be cancelled.
                    </li>
                    <li>10. CAT/MAT/GMAT rank card with valid score.</li>
                </ul>

                <h5 align='center'>LIST OF ELIGIBLE CANDIDATES FOR GD & PI</h5>
                <div className="table-responsive my-4">
                    <h5 className="mb-3" style={{color:"red"}}>Day-1 (19/05/2025)</h5>
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>1</td><td>MB125MS00005</td><td>30</td><td>MB125MS00060</td><td>59</td><td>MB125MS00119</td></tr>
                            <tr><td>2</td><td>MB125MS00007</td><td>31</td><td>MB125MS00063</td><td>60</td><td>MB125MS00121</td></tr>
                            <tr><td>3</td><td>MB125MS00012</td><td>32</td><td>MB125MS00066</td><td>61</td><td>MB125MS00123</td></tr>
                            <tr><td>4</td><td>MB125MS00015</td><td>33</td><td>MB125MS00067</td><td>62</td><td>MB125MS00125</td></tr>
                            <tr><td>5</td><td>MB125MS00016</td><td>34</td><td>MB125MS00068</td><td>63</td><td>MB125MS00127</td></tr>
                            <tr><td>6</td><td>MB125MS00017</td><td>35</td><td>MB125MS00069</td><td>64</td><td>MB125MS00128</td></tr>
                            <tr><td>7</td><td>MB125MS00018</td><td>36</td><td>MB125MS00071</td><td>65</td><td>MB125MS00129</td></tr>
                            <tr><td>8</td><td>MB125MS00020</td><td>37</td><td>MB125MS00072</td><td>66</td><td>MB125MS00130</td></tr>
                            <tr><td>9</td><td>MB125MS00021</td><td>38</td><td>MB125MS00073</td><td>67</td><td>MB125MS00131</td></tr>
                            <tr><td>10</td><td>MB125MS00022</td><td>39</td><td>MB125MS00075</td><td>68</td><td>MB125MS00134</td></tr>
                            <tr><td>11</td><td>MB125MS00023</td><td>40</td><td>MB125MS00076</td><td>69</td><td>MB125MS00137</td></tr>
                            <tr><td>12</td><td>MB125MS00024</td><td>41</td><td>MB125MS00078</td><td>70</td><td>MB125MS00138</td></tr>
                            <tr><td>13</td><td>MB125MS00026</td><td>42</td><td>MB125MS00083</td><td>71</td><td>MB125MS00139</td></tr>
                            <tr><td>14</td><td>MB125MS00031</td><td>43</td><td>MB125MS00085</td><td>72</td><td>MB125MS00140</td></tr>
                            <tr><td>15</td><td>MB125MS00033</td><td>44</td><td>MB125MS00088</td><td>73</td><td>MB125MS00141</td></tr>
                            <tr><td>16</td><td>MB125MS00034</td><td>45</td><td>MB125MS00090</td><td>74</td><td>MB125MS00143</td></tr>
                            <tr><td>17</td><td>MB125MS00038</td><td>46</td><td>MB125MS00093</td><td>75</td><td>MB125MS00144</td></tr>
                            <tr><td>18</td><td>MB125MS00042</td><td>47</td><td>MB125MS00095</td><td>76</td><td>MB125MS00145</td></tr>
                            <tr><td>19</td><td>MB125MS00043</td><td>48</td><td>MB125MS00097</td><td>77</td><td>MB125MS00149</td></tr>
                            <tr><td>20</td><td>MB125MS00045</td><td>49</td><td>MB125MS00098</td><td>78</td><td>MB125MS00150</td></tr>
                            <tr><td>21</td><td>MB125MS00047</td><td>50</td><td>MB125MS00100</td><td>79</td><td>MB125MS00153</td></tr>
                            <tr><td>22</td><td>MB125MS00048</td><td>51</td><td>MB125MS00104</td><td>80</td><td>MB125MS00155</td></tr>
                            <tr><td>23</td><td>MB125MS00049</td><td>52</td><td>MB125MS00105</td><td>81</td><td>MB125MS00156</td></tr>
                            <tr><td>24</td><td>MB125MS00050</td><td>53</td><td>MB125MS00106</td><td>82</td><td>MB125MS00157</td></tr>
                            <tr><td>25</td><td>MB125MS00052</td><td>54</td><td>MB125MS00107</td><td>83</td><td>MB125MS00158</td></tr>
                            <tr><td>26</td><td>MB125MS00054</td><td>55</td><td>MB125MS00109</td><td>84</td><td>MB125MS00159</td></tr>
                            <tr><td>27</td><td>MB125MS00055</td><td>56</td><td>MB125MS00111</td><td>85</td><td>MB125MS00162</td></tr>
                            <tr><td>28</td><td>MB125MS00056</td><td>57</td><td>MB125MS00116</td><td></td><td></td></tr>
                            <tr><td>29</td><td>MB125MS00058</td><td>58</td><td>MB125MS00118</td><td></td><td></td></tr>
                        </tbody>
                    </table>
                </div>


                <div className="table-responsive my-4">
                    <h5 className="mb-3" style={{color:"red"}}>Day-2 (20/05/2025)</h5>
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>86</td><td>MB125MS00163</td><td>115</td><td>MB125MS00220</td><td>144</td><td>MB125MS00325</td></tr>
                            <tr><td>87</td><td>MB125MS00164</td><td>116</td><td>MB125MS00221</td><td>145</td><td>MB125MS00328</td></tr>
                            <tr><td>88</td><td>MB125MS00165</td><td>117</td><td>MB125MS00223</td><td>146</td><td>MB125MS00333</td></tr>
                            <tr><td>89</td><td>MB125MS00166</td><td>118</td><td>MB125MS00225</td><td>147</td><td>MB125MS00336</td></tr>
                            <tr><td>90</td><td>MB125MS00168</td><td>119</td><td>MB125MS00226</td><td>148</td><td>MB125MS00337</td></tr>
                            <tr><td>91</td><td>MB125MS00170</td><td>120</td><td>MB125MS00228</td><td>149</td><td>MB125MS00339</td></tr>
                            <tr><td>92</td><td>MB125MS00171</td><td>121</td><td>MB125MS00232</td><td>150</td><td>MB125MS00342</td></tr>
                            <tr><td>93</td><td>MB125MS00172</td><td>122</td><td>MB125MS00233</td><td>151</td><td>MB125MS00346</td></tr>
                            <tr><td>94</td><td>MB125MS00175</td><td>123</td><td>MB125MS00240</td><td>152</td><td>MB125MS00350</td></tr>
                            <tr><td>95</td><td>MB125MS00178</td><td>124</td><td>MB125MS00241</td><td>153</td><td>MB125MS00352</td></tr>
                            <tr><td>96</td><td>MB125MS00179</td><td>125</td><td>MB125MS00243</td><td>154</td><td>MB125MS00356</td></tr>
                            <tr><td>97</td><td>MB125MS00184</td><td>126</td><td>MB125MS00244</td><td>155</td><td>MB125MS00365</td></tr>
                            <tr><td>98</td><td>MB125MS00185</td><td>127</td><td>MB125MS00252</td><td>156</td><td>MB125MS00369</td></tr>
                            <tr><td>99</td><td>MB125MS00186</td><td>128</td><td>MB125MS00259</td><td>157</td><td>MB125MS00370</td></tr>
                            <tr><td>100</td><td>MB125MS00188</td><td>129</td><td>MB125MS00261</td><td>158</td><td>MB125MS00373</td></tr>
                            <tr><td>101</td><td>MB125MS00189</td><td>130</td><td>MB125MS00264</td><td>159</td><td>MB125MS00374</td></tr>
                            <tr><td>102</td><td>MB125MS00190</td><td>131</td><td>MB125MS00275</td><td>160</td><td>MB125MS00375</td></tr>
                            <tr><td>103</td><td>MB125MS00193</td><td>132</td><td>MB125MS00279</td><td>161</td><td>MB125MS00377</td></tr>
                            <tr><td>104</td><td>MB125MS00197</td><td>133</td><td>MB125MS00281</td><td>162</td><td>MB125MS00380</td></tr>
                            <tr><td>105</td><td>MB125MS00198</td><td>134</td><td>MB125MS00290</td><td>163</td><td>MB125MS00384</td></tr>
                            <tr><td>106</td><td>MB125MS00199</td><td>135</td><td>MB125MS00291</td><td>164</td><td>MB125MS00389</td></tr>
                            <tr><td>107</td><td>MB125MS00202</td><td>136</td><td>MB125MS00292</td><td>165</td><td>MB125MS00395</td></tr>
                            <tr><td>108</td><td>MB125MS00205</td><td>137</td><td>MB125MS00293</td><td>166</td><td>MB125MS00396</td></tr>
                            <tr><td>109</td><td>MB125MS00206</td><td>138</td><td>MB125MS00303</td><td>167</td><td>MB125MS00398</td></tr>
                            <tr><td>110</td><td>MB125MS00207</td><td>139</td><td>MB125MS00312</td><td>168</td><td>MB125MS00404</td></tr>
                            <tr><td>111</td><td>MB125MS00210</td><td>140</td><td>MB125MS00314</td><td>169</td><td>MB125MS00407</td></tr>
                            <tr><td>112</td><td>MB125MS00212</td><td>141</td><td>MB125MS00317</td><td>170</td><td>MB125MS00408</td></tr>
                            <tr><td>113</td><td>MB125MS00214</td><td>142</td><td>MB125MS00322</td><td></td><td></td></tr>
                            <tr><td>114</td><td>MB125MS00217</td><td>143</td><td>MB125MS00324</td><td></td><td></td></tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive my-4">
                    <h5 className="mb-3" style={{color:"red"}}>Day-3 (21/05/2025)</h5>
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                                <th>S.No</th>
                                <th>Application No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr><td>171</td><td>MB125MS00412</td><td>200</td><td>MB125MS00478</td><td>229</td><td>MB125MS00529</td></tr>
                            <tr><td>172</td><td>MB125MS00421</td><td>201</td><td>MB125MS00480</td><td>230</td><td>MB125MS00530</td></tr>
                            <tr><td>173</td><td>MB125MS00423</td><td>202</td><td>MB125MS00483</td><td>231</td><td>MB125MS00531</td></tr>
                            <tr><td>174</td><td>MB125MS00424</td><td>203</td><td>MB125MS00487</td><td>232</td><td>MB125MS00533</td></tr>
                            <tr><td>175</td><td>MB125MS00425</td><td>204</td><td>MB125MS00488</td><td>233</td><td>MB125MS00535</td></tr>
                            <tr><td>176</td><td>MB125MS00427</td><td>205</td><td>MB125MS00489</td><td>234</td><td>MB125MS00536</td></tr>
                            <tr><td>177</td><td>MB125MS00428</td><td>206</td><td>MB125MS00490</td><td>235</td><td>MB125MS00537</td></tr>
                            <tr><td>178</td><td>MB125MS00433</td><td>207</td><td>MB125MS00492</td><td>236</td><td>MB125MS00541</td></tr>
                            <tr><td>179</td><td>MB125MS00437</td><td>208</td><td>MB125MS00501</td><td>237</td><td>MB125MS00544</td></tr>
                            <tr><td>180</td><td>MB125MS00438</td><td>209</td><td>MB125MS00505</td><td>238</td><td>MB125MS00545</td></tr>
                            <tr><td>181</td><td>MB125MS00441</td><td>210</td><td>MB125MS00506</td><td>239</td><td>MB125MS00550</td></tr>
                            <tr><td>182</td><td>MB125MS00442</td><td>211</td><td>MB125MS00507</td><td>240</td><td>MB125MS00551</td></tr>
                            <tr><td>183</td><td>MB125MS00443</td><td>212</td><td>MB125MS00510</td><td>241</td><td>MB125MS00560</td></tr>
                            <tr><td>184</td><td>MB125MS00445</td><td>213</td><td>MB125MS00512</td><td>242</td><td>MB125MS00564</td></tr>
                            <tr><td>185</td><td>MB125MS00447</td><td>214</td><td>MB125MS00513</td><td>243</td><td>MB125MS00566</td></tr>
                            <tr><td>186</td><td>MB125MS00449</td><td>215</td><td>MB125MS00514</td><td>244</td><td>MB125MS00567</td></tr>
                            <tr><td>187</td><td>MB125MS00455</td><td>216</td><td>MB125MS00515</td><td>245</td><td>MB125MS00568</td></tr>
                            <tr><td>188</td><td>MB125MS00456</td><td>217</td><td>MB125MS00516</td><td>246</td><td>MB125MS00574</td></tr>
                            <tr><td>189</td><td>MB125MS00458</td><td>218</td><td>MB125MS00517</td><td>247</td><td>MB125MS00575</td></tr>
                            <tr><td>190</td><td>MB125MS00460</td><td>219</td><td>MB125MS00518</td><td>248</td><td>MB125MS00579</td></tr>
                            <tr><td>191</td><td>MB125MS00462</td><td>220</td><td>MB125MS00519</td><td>249</td><td>MB125MS00582</td></tr>
                            <tr><td>192</td><td>MB125MS00464</td><td>221</td><td>MB125MS00520</td><td>250</td><td>MB125MS00583</td></tr>
                            <tr><td>193</td><td>MB125MS00465</td><td>222</td><td>MB125MS00521</td><td>251</td><td>MB125MS00584</td></tr>
                            <tr><td>194</td><td>MB125MS00466</td><td>223</td><td>MB125MS00522</td><td>252</td><td>MB125MS00587</td></tr>
                            <tr><td>195</td><td>MB125MS00468</td><td>224</td><td>MB125MS00524</td><td>253</td><td>MB125MS00588</td></tr>
                            <tr><td>196</td><td>MB125MS00472</td><td>225</td><td>MB125MS00525</td><td></td><td></td></tr>
                            <tr><td>197</td><td>MB125MS00474</td><td>226</td><td>MB125MS00526</td><td></td><td></td></tr>
                            <tr><td>198</td><td>MB125MS00475</td><td>227</td><td>MB125MS00527</td><td></td><td></td></tr>
                            <tr><td>199</td><td>MB125MS00476</td><td>228</td><td>MB125MS00528</td><td></td><td></td></tr>
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive my-5">
                    <h5 className="mb-3 center" align='center'>MBA Admissions Process Schedule</h5>
                    <p className="fst-italic" align='center'>*The schedule remains the same for 19<sup>th</sup>, 20<sup>th</sup> & 21<sup>st</sup> May 2025</p>
                    <table className="table table-bordered table-striped">
                        <thead className="table-dark">
                            <tr>
                                <th>Time</th>
                                <th>Activity</th>
                                <th>Venue</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>8:30 am</td>
                                <td>Reporting</td>
                                <td>Raman Hall, I Floor, Seminar Halls Complex, NIT Warangal</td>
                            </tr>
                            <tr>
                                <td>9:00 am</td>
                                <td>Briefing about the Department and interaction with the faculty</td>
                                <td>Raman Hall, Seminar Halls Complex, NIT Warangal</td>
                            </tr>
                            <tr>
                                <td>9:20 am</td>
                                <td>Tea Break</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>9:30 am</td>
                                <td>Verification of certificates</td>
                                <td>MBA II year classroom, I Floor, Department of Management Studies</td>
                            </tr>
                            <tr>
                                <td>10:00 am onwards</td>
                                <td>Group Discussion</td>
                                <td>Analytics Lab, II Floor, Department of Management Studies</td>
                            </tr>
                            <tr>
                                <td>10:30 am onwards</td>
                                <td>Panel 1 – Interviews</td>
                                <td>HoD Chamber, I Floor, Department of Management Studies</td>
                            </tr>
                            <tr>
                                <td>10:30 am onwards</td>
                                <td>Panel 2 – Interviews</td>
                                <td>MBA First Year Classroom, I Floor, Department of Management Studies</td>
                            </tr>
                            <tr>
                                <td>1:00–2:00 pm</td>
                                <td>Lunch Break</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>2:00 pm onwards</td>
                                <td>Panel 1 – Interviews</td>
                                <td>HoD Chamber, I Floor, Department of Management Studies</td>
                            </tr>
                            <tr>
                                <td>2:00 pm onwards</td>
                                <td>Panel 2 – Interviews</td>
                                <td>MBA First Year Classroom, I Floor, Department of Management Studies</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p>
                    The Institute has limited accommodation facility in NIT Guest House. For booking-related queries, booking confirmation, all correspondence, suggestions, and feedback, email to:
                    <a href="mailto:ghnitw@nitw.ac.in">ghnitw@nitw.ac.in</a>.
                    More details can be obtained by
                    <a href="#https://nitw.ac.in/page/?url=/guesthouse/2021" target="_blank">clicking here</a>.
                </p>

                <p>
                    Alternatively, hotels are also available nearby the institute. The candidates are requested to plan their itinerary as per the schedule.
                </p>







            </div>
        </div>
    );
};

export default MBAwrittentest;